import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { I18nService } from '../services/i18n.service';

// doivent être importés explicitement)
// TODO voir is possible de lire génériquement
import {
  CONVERTED_UNIT as CONVERTED_UNIT_en,
  LOCALE as LOCALE_en,
  PUNCTUATION_FORMATTER as PUNCTUATION_FORMATTER_en,
  TRANSLATIONS as TRANSLATIONS_en,
  UNIT_CONVERTER as UNIT_CONVERTER_en,
} from './en';
import {
  CONVERTED_UNIT as CONVERTED_UNIT_en_UK,
  COUNTRY as COUNTRY_UK,
  DATE_FORMATTER as DATE_FORMATTER_en_UK,
  NUMBER_FORMATTER as NUMBER_FORMATTER_en_UK,
  UNIT_CONVERTER as UNIT_CONVERTER_en_UK,
} from './en-UK';
import {
  CONVERTED_UNIT as CONVERTED_UNIT_fr,
  DATE_FORMATTER as DATE_FORMATTER_fr,
  LOCALE as LOCALE_fr,
  NUMBER_FORMATTER as NUMBER_FORMATTER_fr,
  PUNCTUATION_FORMATTER as PUNCTUATION_FORMATTER_fr,
  TRANSLATIONS as TRANSLATIONS_fr,
  UNIT_CONVERTER as UNIT_CONVERTER_fr,
} from './fr';

@Injectable({ providedIn: 'root' })
export class I18nTranslator {
  private translations: Map<string, any>;
  private unitConverter: Function;
  private unitNameConverter: Function;
  private numberFormatter: Function;
  private dateFormatter: Function;
  private punctuationFormatter: Function;

  private locale: string;
  private language: string;
  private country: string;

  constructor(
    private i18nService: I18nService,
    private sanitizer: DomSanitizer,
  ) {
    // ne change pas pendant la vie de l'application
    // (si changé : application est rechargée)
    // les chaines pour la locale spécifique sont statiques une fois chargées
    this.locale = this.i18nService.i18nInfo.languageGuiCode;
    this.language = this.i18nService.i18nInfo.languageGuiCode_lang_code;
    this.country = this.i18nService.i18nInfo.languageGuiCode_country_code;

    this.merge_translations();
  }

  private merge_translations() {
    this.translations = new Map<string, any>();

    // TODO default locale à charger d'avance ? puis les autres qui ont la priorité par dessus

    // on connait la liste des locales supportées
    // tout est explicite
    if (this.language == LOCALE_fr) {
      this.mergeTranslations(TRANSLATIONS_fr);
      this.setFormatters(DATE_FORMATTER_fr, NUMBER_FORMATTER_fr, PUNCTUATION_FORMATTER_fr);
      this.setConverters(UNIT_CONVERTER_fr, CONVERTED_UNIT_fr);
    } else if (this.language == LOCALE_en) {
      // TODO avoir fichier de localisation pour un pays donné (indépendant de la langue)
      this.mergeTranslations(TRANSLATIONS_en);
      // ponctuation identique pour tous les EN
      // conventions EN UK par défaut ; pour les dates, d.toLocaleDateString('en') => convention USA
      // donc plutot en-UK
      // FIXME DATE_FORMATTER_en_UK => utiliser plutot un format commun pour un pays ; pareil pour number
      // et ponctuation
      this.setFormatters(DATE_FORMATTER_en_UK, NUMBER_FORMATTER_en_UK, PUNCTUATION_FORMATTER_en);
      this.setConverters(UNIT_CONVERTER_en, CONVERTED_UNIT_en);

      if (this.country == COUNTRY_UK) {
        // pas de traduction spécifique pour en-UK
        // juste les conversions
        this.setConverters(UNIT_CONVERTER_en_UK, CONVERTED_UNIT_en_UK);
      } else {
        // TODO specifique aux pays ; voir l'écriture de l'unité diffère selon la langue
      }
    }
  }

  private mergeTranslations(messages: Map<string, any>) {
    messages.forEach((value, key) => {
      this.translations.set(key, value);
    });
  }

  private setFormatters(dateFormatter: Function, numberFormatter: Function, punctuationFormatter: Function) {
    this.dateFormatter = dateFormatter;
    this.numberFormatter = numberFormatter;
    this.punctuationFormatter = punctuationFormatter;
  }

  private setConverters(unitConverter: Function, convertedUnit: Function) {
    this.unitConverter = unitConverter;
    this.unitNameConverter = convertedUnit;
  }

  translate(key: string, ...params: any[]): any {
    // pas de bypassSecurityTrustUrl par défault car il faut binder le résultat (cf home.component.html)
    // utiliser la pipe safe + binder si la chaine a du HTML
    // sinon utiliser juste {{}}
    const value: any = this.translations.get(key);
    if (!value) {
      return key;
    }
    if (typeof value === 'string') {
      return value;
    }
    if (typeof value === 'function') {
      return value(...params);
    }
    return key;
  }

  convertFromUnit(unit: string, ha: number) {
    return this.unitConverter(unit, ha);
  }

  convertUnitName(unit: string, isPlural = false) {
    return this.unitNameConverter(unit, isPlural);
  }

  formatNumber(n: number, options: any = null) {
    if (n == null || n == undefined) {
      return '';
    }
    return this.numberFormatter(n, options);
  }

  formatDate(d: Date) {
    if (!d) {
      return '';
    }
    return this.dateFormatter(d);
  }

  formatPunctuation(str: string) {
    if (!str) {
      return '';
    }
    return this.punctuationFormatter(str);
  }

  imageUrl(imageType: string, extension: string = '.png') {
    return this.sanitizer.bypassSecurityTrustUrl('/assets/img/' + imageType + '_' + this.language + extension);
  }
}
